import styles from "../styles.module.scss";
import localStyles from "./styles.module.scss";
import ColorOption from "../ColorOption";
import { useAppData } from "../../context/Contexts";
import { useEffect, useState } from "react";
import { getCurrency, parseSeatValue, withPartNumberSkuBody } from "../../helpers/helpers";

export default function StepNoCompatible(props) {
  const { currentAppData, setCurrentAppData } = useAppData();
  const [name, setName] = useState(undefined);
  const [phone, setPhone] = useState(undefined);
  const [formSent, setFormSent] = useState(false);

  const [errorName, setErrorName] = useState(false);
  const [errorPhone, setErrorPhone] = useState(false);
  const [incompatible, setIncompatible] = useState<boolean>(false);
  const [customincompatible, setCustomincompatible] = useState<boolean>(false);

  const seat = "";

  useEffect(() => {
    if (
      window.location.href.indexOf("custom-luxury-seat-covers") === -1 &&
      incompatible === true
    ) {
      // window.location.href = `/products/custom-luxury-seat-covers?year=${currentAppData.year}` +
      //      `&make=${currentAppData.make}&model=${currentAppData.model}`;
    }
  }, [incompatible]);

  useEffect(() => {
    setIncompatible(
      typeof currentAppData?.check !== "undefined" &&
        (currentAppData?.check?.compatibility === "N" ||
          currentAppData?.check?.compatibility === "A") &&
        //&& currentAppData?.check?.compatibility_custom === 'Y'
        currentAppData?.step > 1 &&
        (window.location.href.indexOf("custom-luxury-seat-covers") === -1
            || window.scs_force_normal === true)
    );

    const testCustomCompatibility = typeof currentAppData?.check !== "undefined" &&
        (currentAppData?.check?.compatibility === "N" ||
            currentAppData?.check?.compatibility === "A") &&
        currentAppData?.check?.compatibility_custom === "N" &&
        currentAppData?.step === 3 &&
        (window.location.href.indexOf("custom-luxury-seat-covers") !== -1
            || window.scs_force_custom === true)

      // console.log('testCustomCompatibility', testCustomCompatibility)
      setCustomincompatible(testCustomCompatibility);

  }, [currentAppData]);

  // console.log(
  //   "incompatible=",
  //   currentAppData?.check?.compatibility,
  //   typeof currentAppData?.check !== "undefined" &&
  //     !!currentAppData?.check?.compatibility,
  //   incompatible,
  //     currentAppData?.step,
  // );
  // console.log("currentAppData.check", currentAppData?.check);

  // return <>
  // {customincompatible ? (
  //     <div className={`${styles.custom_alert}`}>
  //
  //         <p>🎉 Good News! While your vehicle isn't compatible with our universal seat covers, you may qualify for our guaranteed-fit affordable custom-made solution!</p>
  //
  //         <p>
  //             <a href="/products/custom-luxury-seat-covers" className={`${styles.btn}`}>
  //                 View Our Custom Seat Covers  👉
  //             </a>
  //         </p>
  //     </div>): ''}
  // </>;

  const handleNameChange = (e) => {
    setName(e.target.value);
    if (!name || name.trim() === "") {
      setErrorName(true);
    } else {
      setErrorName(false);
    }
  };

  const handlePhoneChange = (e) => {
    setPhone(e.target.value);
    if (!phone || phone.trim() === "") {
      setErrorPhone(true);
    } else {
      setErrorPhone(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name) {
      setErrorName(true);
    }
    if (!phone) {
      setErrorPhone(true);
    }
    if (!name || !phone) {
      return;
    }

    const dd = { name: name, phone: phone };

    dd["vehicle"] =
      `${currentAppData.year} ${currentAppData.make} ${currentAppData.model} ${currentAppData.trim}`;

    fetch("https://scsbiz.wearevisum.com/api/v1/form-not-compatible", {
      method: "POST",
      body: JSON.stringify(withPartNumberSkuBody(dd)),
    }).then((response) => {
      setFormSent(true);
      const gtag = (globalThis as any).gtag;
      if (typeof gtag === "function") {
        gtag("event", "no_compatible_form_submitted", {
          event_category: "engagement",
          event_label: dd["vehicle"],
        });
      }
    });
  };

  return (
    <>
      {!window.scs_force_custom && incompatible && !window.scs_h1_fallback ? (
        <>
          <section
            className={`${styles.section__step} ${styles.section_active} `}
            id="step_4"
          >
            <div className={`${styles.custom_alert}`}>
              <p>
                🎉 Good News! While your vehicle isn't compatible with our
                universal seat covers, you may qualify for our guaranteed-fit
                affordable custom-made solution!
              </p>
              <p>
                <a
                  href={`/products/custom-luxury-seat-covers?year=${currentAppData.year}&make=${currentAppData.make}`}
                  className={`${styles.btn}`}
                >
                  View Our Custom Seat Covers 👉
                </a>
              </p>
            </div>
          </section>
        </>
      ) : !window.scs_force_custom && incompatible && !!window.scs_h1_fallback ? (
        <>
          <section
            className={`${styles.section__step} ${styles.section_active} `}
            id="step_4"
          >
            <form onSubmit={handleSubmit}>
              <h2>
                Step 3/3 - <strong>Final Step</strong>
              </h2>
              {!formSent ? (
                <>
                  <p>Your vehicle is not compatible. </p>
                  <p>
                    Please enter your name & number below, so we can better
                    assist you.
                  </p>

                  {!name || !phone ? (
                    <p className={`${styles.form_error}`}>
                      Please enter the name and phone number
                    </p>
                  ) : (
                    ""
                  )}

                  <div className={`${styles.input_wrapper}`}>
                    <div className={`${styles.form_control_text}`}>
                      {errorName}
                      <input
                        type="text"
                        name="name"
                        placeholder="name"
                        value={name ? name : ""}
                        onChange={handleNameChange}
                        className={`form_control ${errorName ? styles.error : ""}`}
                      />
                    </div>
                    <div className={`${styles.form_control_text}`}>
                      {errorPhone}
                      <input
                        type="tel"
                        name="phone"
                        placeholder="phone"
                        value={phone ? phone : ""}
                        onChange={handlePhoneChange}
                        className={`form_control ${errorPhone ? styles.error : ""}`}
                      />
                    </div>
                  </div>

                  <div className={`${styles.btn_wrapper}`}>
                    <button type="submit" className={styles.btn}>
                      <span className={`${styles.btn_inner}`}>
                        Send{" "}
                        <svg
                          width="10"
                          height="15"
                          viewBox="0 0 10 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.78125 6.49731L3.33496 1.05103C2.74902 0.465088 1.80273 0.465088 1.2168 1.05103C0.630859 1.63696 0.630859 2.58325 1.2168 3.16919L5.60547 7.55493L1.2168 11.9407C0.630859 12.5266 0.630859 13.4729 1.2168 14.0588C1.80273 14.6448 2.74902 14.6448 3.33496 14.0588L8.78125 8.61255C9.36426 8.02954 9.36426 7.08032 8.78125 6.49731Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </button>
                  </div>
                </>
              ) : (
                <p className={`${styles.success}`}>
                  Thank you for contacting us. We will get back to you shortly.
                </p>
              )}
            </form>
          </section>
        </>
      ) : (
        ""
      )}

      {window.scs_force_custom && customincompatible ? (
        <>
          <section
            className={`${styles.section__step} ${styles.section_active} `}
            id="step_4"
          >
            <form onSubmit={handleSubmit}>
              <h2>
                Step 3/3 - <strong>Final Step</strong>
              </h2>
              {!formSent ? (
                <>
                  <p>Your vehicle is not compatible. </p>
                  {/*<p>YOU QUALIFY FOR CUSTOM-MADE SEAT COVERS</p>*/}
                  <p>
                    Please enter your name & number below, so we can better
                    assist you.
                  </p>

                  {!name || !phone ? (
                    <p className={`${styles.form_error}`}>
                      Please enter the name and phone number
                    </p>
                  ) : (
                    ""
                  )}

                  <div className={`${styles.input_wrapper}`}>
                    <div className={`${styles.form_control_text}`}>
                      {errorName}
                      <input
                        type="text"
                        name="name"
                        placeholder="name"
                        value={name ? name : ""}
                        onChange={handleNameChange}
                        className={`form_control ${errorName ? styles.error : ""}`}
                      />
                    </div>
                    <div className={`${styles.form_control_text}`}>
                      {errorPhone}
                      <input
                        type="tel"
                        name="phone"
                        placeholder="phone"
                        value={phone ? phone : ""}
                        onChange={handlePhoneChange}
                        className={`form_control ${errorPhone ? styles.error : ""}`}
                      />
                    </div>
                  </div>

                  <div className={`${styles.btn_wrapper}`}>
                    <button type="submit" className={styles.btn}>
                      <span className={`${styles.btn_inner}`}>
                        Send{" "}
                        <svg
                          width="10"
                          height="15"
                          viewBox="0 0 10 15"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.78125 6.49731L3.33496 1.05103C2.74902 0.465088 1.80273 0.465088 1.2168 1.05103C0.630859 1.63696 0.630859 2.58325 1.2168 3.16919L5.60547 7.55493L1.2168 11.9407C0.630859 12.5266 0.630859 13.4729 1.2168 14.0588C1.80273 14.6448 2.74902 14.6448 3.33496 14.0588L8.78125 8.61255C9.36426 8.02954 9.36426 7.08032 8.78125 6.49731Z"
                            fill="white"
                          />
                        </svg>
                      </span>
                    </button>
                  </div>
                </>
              ) : (
                <p className={`${styles.success}`}>
                  Thank you for contacting us. We will get back to you shortly.
                </p>
              )}
            </form>
          </section>
        </>
      ) : (
        ""
      )}
    </>
  );
}

